import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import type { TenantListItemDto } from "Infrastructure/Api/Api";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { CreateTenantDialog } from "Tenants/Components/CreateTenantDialog";
import { TenantsTable } from "Tenants/Components/TenantsTable";
import { type FC, useState } from "react";

export const TenantsPage: FC = () => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [editTenant, setEditTenant] = useState<TenantListItemDto | undefined>(
		undefined,
	);

	const handleCreateClick = () => {
		setEditTenant(undefined);
		setIsDialogOpen(true);
	};

	const handleEditClick = (tenant: TenantListItemDto) => {
		setEditTenant(tenant);
		setIsDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setIsDialogOpen(false);
		setEditTenant(undefined);
	};

	return (
		<AuthenticatedLayout title="Tenants">
			<Box>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					mb={2}
				>
					<Typography variant="h4">Tenants</Typography>
					<Button
						variant="contained"
						color="primary"
						startIcon={<AddIcon />}
						onClick={handleCreateClick}
					>
						Create Tenant
					</Button>
				</Stack>
				<TenantsTable onEdit={handleEditClick} />
				<CreateTenantDialog
					open={isDialogOpen}
					onClose={handleCloseDialog}
					editData={editTenant}
				/>
			</Box>
		</AuthenticatedLayout>
	);
};
